/**
 * 全局事件总线
 */

var names = {
  //所有事件名必须在此声明
  USER_LOGIN_STATE_CHANGE: 'userLoginStateChange',
  //用户登录状态变更
  USER_INFO_CHANGE_EVENT: 'userInfoChange',
  //用户信息变更
  CART_CHANGE: 'cartChange',
  //购物车有变更
  CART_SELECT_STATE_CHANGE: 'cartSelectStateChange',
  //购物车选中状态变更
  GET_ORDER_COUNT: 'getOrderCount',
  //获取到不同状态订单数量
  ORDER_STATE_CHANGE: 'orderStateChange',
  //有订单状态发生变化

  CLOUD_API_CHANGE: 'cloudApiChange',
  //云端接口有變化

  ADDRESS_LIST_GET: 'getAddressList',
  //获取到收货地址列表
  ADDRESS_SELECTED: 'selectAddress',
  //结算页面接收选中地址事件

  SUBMIT_AFTERSALE_SUCCESS: 'submitAfterSaleSuccess',
  //提交了新的售后请求

  GET_UI_SETTINGS_EVENT: 'getUiSettings',
  //获取到了app界面配置

  REFRESH_WEBVIEW_EVENT: 'refreshWebview',
  //刷新webview页面

  LIST_STYLE_CHANGED: 'listStyleChanged',
  //列表风格变化

  TAB_PAGE_STATUS_CHANGE: 'tabPageStatusChanged', //tab页显示状态变更
}
const getGuid = () => {
  const s = [];
  const hexDigits = "0123456789abcdef";
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  // eslint-disable-next-line no-bitwise
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  // eslint-disable-next-line no-multi-assign
  s[8] = s[13] = s[18] = s[23] = "-";

  const uuid = s.join("");
  return uuid;
}

/**
 * 事件集合
 */
var events = {}

if (typeof window["pageToken"] === typeof undefined) {
  window["pageToken"] = getGuid();
  const storageChangedListener = (event) => {
      const storageKey = event["key"];
      if (storageKey.indexOf("eventBus_") === 0) {
          const eventName = storageKey.substr(9)
          const msg = JSON.parse(event["newValue"]);
          const page = msg.pageToken;
          const { data } = msg;
          if (page !== window["pageToken"]) {
              const callbacks = events[eventName];
              if (Array.isArray(callbacks)) {
                  // eslint-disable-next-line array-callback-return
                  callbacks.map((listener) => {
                      const callback = listener;
                      callback(data);
                  })
              }
          }
      }
  };
  window.addEventListener("storage", storageChangedListener);
}

/**
 * 注册/订阅事件
 * name：事件名
 * callback：事件监听器/回调
 */
function register(name, callback) {
  const listener = callback;
  const callbacks = events[name];
  if (Array.isArray(callbacks)) {
      // 检查是否已经注册，避免重复注册
      const current = callbacks.find((item) => {
          return item === callback;
      })
      if (!current) {
          callbacks.push(listener);
      }
  } else {
      events[name] = [listener];
  }
}


/**
 * 解注册/取消订阅事件
 */
function unregister(name, callback) {
  const callbacks = events[name];
  if (Array.isArray(callbacks)) {
      events[name] = callbacks.filter((listener) => {
          return listener !== callback;
      })
  }
}


/**
 * 发送事件
 * name：事件名。为方便统一管理，app内所有事件必须在names中声明
 * data：事件附加信息
 * crossPage：是否跨页面通信
 */
function send(name, data, crossPage) {
  if (crossPage) {
      window.localStorage.setItem(
          `eventBus_${name}`,
          JSON.stringify({
              data,
              token: getGuid(),
              pageToken: window["pageToken"]
          })
      )
  }
  const callbacks = events[name];
  if (Array.isArray(callbacks)) {
      // eslint-disable-next-line array-callback-return
      callbacks.map((listener) => {
          const callback = listener;
          callback(data);
      })
  }
}


module.exports = {
  register,
  unregister,
  send,
  names: names,
}
